// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N1X0","label":"styles_label__2WCza"};